import { render, staticRenderFns } from "./ProductRecommendations.vue?vue&type=template&id=0c8d5b72&scoped=true&"
import script from "./ProductRecommendations.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommendations.vue?vue&type=style&index=0&id=0c8d5b72&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d5b72",
  null
  
)

export default component.exports